import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { uniq } from 'lodash';
import React, { useMemo } from 'react';
import { IConsoleAuth } from 'types/login';
import { AuthContext } from 'hooks/useAuth';
import { IProjectData, ProjectContext } from 'routes/ProjectProvider';

const ProjectsCell: React.FC<GridRenderCellParams<any>> = ({ row }) => {
	const { consoleUser } = React.useContext<IConsoleAuth>(AuthContext);
	const { currentProject } = React.useContext<IProjectData>(ProjectContext);
	const currentCompanyId = useMemo(
		() =>
			consoleUser?.projects?.find((p) => p.id === currentProject)?.companyId ||
			'',
		[consoleUser?.projects, currentProject]
	);

	const projects = useMemo(
		() =>
			consoleUser?.projects?.filter((p) => p.companyId === currentCompanyId),
		[consoleUser.projects, currentCompanyId]
	);
	const projectsMap = useMemo(() => {
		const res: Record<string, string> = {};
		projects?.forEach((p) => {
			if (p.companyId === currentCompanyId) {
				res[p.id] = p.name;
			}
		});
		return res;
	}, [projects, currentCompanyId]);

	const display = React.useMemo(() => {
		const prNames = (row.permittedProjects || []).map(
			(m: string) => projectsMap[m]
		);
		return (
			uniq(prNames).sort().join(', ') ||
			intl.tr('fields.accessKeys.permittedProjects.all')
		);
	}, [row.permittedProjects, projectsMap]);

	return (
		<Typography
			color="text.secondary"
			variant="body2"
			title={display}
			data-testid="projects-cell"
		>
			{display}
		</Typography>
	);
};

export default ProjectsCell;
